import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from './component-can-deactivate';

@Injectable()
export class CanDeactivateGuard
  implements CanDeactivate<ComponentCanDeactivate>
{
  constructor(private transloco: TranslocoService) {}

  public canDeactivate(
    component: ComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ) {
    if (component) {
      if (component.canDeactivate(nextState)) {
        return true;
      } else {
        return new Observable<boolean>((obs) => {
          obs.next(
            window.confirm(
              this.transloco.translate('ACTIONS.LEAVING_PAGE_CONFIRMATION') +
                ' ' +
                this.transloco.translate('ACTIONS.UNSAVED_CHANGES_WILL_BE_LOST')
            )
          );
          obs.complete();
        });
      }
    }
  }
}
